var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBottomRight = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03127 21.5996L20.7679 21.5996C21.227 21.5996 21.5996 21.227 21.5996 20.7679L21.5996 8.03127C21.5996 7.5722 21.227 7.19961 20.7679 7.19961C20.3089 7.19961 19.9363 7.57219 19.9363 8.03127L19.9363 19.9363L8.03127 19.9363C7.5722 19.9363 7.19961 20.3089 7.19961 20.7679C7.19961 21.227 7.5722 21.5996 8.03127 21.5996Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7532 13.4788L5.58463 4.31023C5.23316 3.95876 4.66331 3.95876 4.31184 4.31023C3.96037 4.6617 3.96037 5.23155 4.31184 5.58302L13.4804 14.7516L11.5712 16.6608L16.656 16.6544L16.6624 11.5696L14.7532 13.4788Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBottomRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bottom-right.9e7c80cd.svg";
export { ForwardRef as ReactComponent };